import { SET_PATH_PARAMS, CLEAR_PATH_PARAMS } from "../actions/path_params_actions";

const initialState = {
    uid: '',
    token: '',
    slug1: '',
    slug2: '',
    slug3: '',
    slug4: ''
};

export const pathParamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PATH_PARAMS: {
      return {
        ...state,
          uid: action.uid,
          token: action.token,
          slug1: action.slug1,
          slug2: action.slug2,
          slug3: action.slug3,
          slug4: action.slug4
      }
    }
    case CLEAR_PATH_PARAMS: {
      return {
        ...state,
          uid: '',
          token: '',
          slug1: '',
          slug2: '',
          slug3: '',
          slug4: ''
      }
    }
    default: return state;
  }
}
